import httpUtils from '../../utils/HttpUtils'

class OnestopCaseArticleService {

  async getList (caseId='',companyId = '') {
    var result = null;
    try {
      result = await httpUtils.post('/onestop/case/article/list',{caseId,companyId});
    } catch (e) {
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }
}
export default new OnestopCaseArticleService()
